"use client";

import { useSignupFlowStore } from "./useSignUpFlowStore";

/**
 * Generic hook to detect if the user has a specific discount code applied.
 * Useful for A/B tests where users enter through landing pages with unique codes.
 *
 * @param targetDiscountCode - The discount code to check for (case-insensitive)
 * @returns Object containing isTestVariant boolean and the current discount code
 *
 */

export const useDiscountCodeTestVariant = (targetDiscountCode: string) => {
  const discountCode = useSignupFlowStore((state) => state.subscription.discount?.discountCode);

  const isTestVariant = discountCode?.toUpperCase() === targetDiscountCode.toUpperCase();

  return {
    isTestVariant,
    currentDiscountCode: discountCode,
  };
};

export const useFresh10TestVariant = () => useDiscountCodeTestVariant("FRESH10");
